module.exports = __webpack_public_path__ + "img/Jim Thompson.f03e3870.webp";